import RemainBalancePerTransaction from './RemainBalancePerTransaction';

export default RemainBalancePerTransaction;
